const ButtonTextIcon = ({ icon, title, className = "", ...rest }) => {
	return (
		<button
			className={`button-IconOnly ${className}`}
			aria-label={title}
			{...rest}
		>
			<span className="w-5 h-5">{icon}</span>
		</button>
	);
};

export default ButtonTextIcon;
